export { default } from './ViewAttachments';
